module.exports = __webpack_public_path__ + "static/img/data-dl-bg.ff2f7ed5.png";